import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import bankAccounts from 'modules/payroll_bundle/store/collections/bankAccounts'
import paymentItems from 'modules/payroll_bundle/store/collections/paymentItems'
import payments from 'modules/payroll_bundle/store/collections/payments'

/*
  Similarly to useFetchPaymentData, this hook fetches ALL the payments in the current policy
  instead of only bringing the selected period payments, you can pass and array of period Ids to specify from which
  periods you want to fetch the payments information.
*/
export const useFetchPolicyPaymentsData = (periodIdList?: string[]) => {
  const { currentPolicyPeriods, policyId } = usePolicyPeriods()

  const { loading: isLoading } = useAsyncData(async () => {
    const data = {
      data: {
        policy_period_ids: periodIdList
          ? periodIdList
          : currentPolicyPeriods.map((period) => period.id),
      },
    }

    await Promise.all([bankAccounts.fetch(), payments.fetch(data), paymentItems.fetch(data)])
  }, [policyId])

  return { isLoading }
}
